import type { AnalyticsQuery } from "schemas/generated/analyticsRead";
import type { Funnel } from "schemas/generated/funnel";

import { DEFAULT_METRICS } from "@/features/analytics/constants";
import useBasicAnalyticsRead from "@/features/analytics/useBasicAnalyticsRead";
import useUrlHosts from "@/features/analytics/useUrlHosts";
import { getRangesFromTimePeriod } from "analytics-utils";
import { startOfDay } from "date-fns";
import { filterNulls } from "replo-utils/lib/array";
import {
  ConditionOperatorEnum,
  PageTypeEnum,
} from "schemas/generated/analyticsRead";

export const useFunnelAnalytics = (funnel: Funnel, timeZone: string) => {
  const urlHostsObj = useUrlHosts();

  const ranges = getRangesFromTimePeriod({
    selectedTimePeriod: {
      type: "custom",
      value: {
        from: startOfDay(new Date(funnel.createdAt)).getTime(),
        to: Date.now(),
      },
    },
    chartInterval: null,
    timeZone,
  }).updatedRanges;

  const funnelRoutes = filterNulls(
    funnel.funnelSteps.map((step) => step.file?.pageRoute),
  );

  const queryConfig: AnalyticsQuery = {
    ranges,
    sortMetric: "unique_sessions",
    order: "DESC",
    limit: 20,
    offset: 0,
    filters: {
      urlPath: [
        {
          operator: ConditionOperatorEnum.EQUALS,
          value: funnelRoutes,
        },
      ],
      pageType: PageTypeEnum.ALL_PAGES,
      urlParams: {},
    },
    mode: "funnel",
    urlHosts: urlHostsObj.data,
    metrics: DEFAULT_METRICS,
    isFractional: false,
  };

  const {
    mainRangeResults,
    isLoading: isFunnelAnalyticsLoading,
    queryHasNoData,
  } = useBasicAnalyticsRead({
    type: "withoutUrlSyncQuery",
    queryConfig,
  });

  const isLoading = isFunnelAnalyticsLoading || urlHostsObj.isLoading;

  return {
    funnelRoutes,
    mainRangeResults,
    queryHasNoData,
    isLoading,
  };
};
